import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface TelefoneBloqueado {
    id: number
    pais: string
    telefone: string
    observacao: string
}

export interface CadastrarPayload {
    pais: string
    telefone: string
    observacao: string
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (isErroBackend(data)) {
        return { codErro: data.codErro, mensagem: data.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterTelefonesBloqueados = async function (
    authorization: string
): Promise<TelefoneBloqueado[] | ErroApi> {
    try {
        const response = await api
            .get<TelefoneBloqueado[] | RespostaErroRaw>("telefone-bloqueado/listar", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as TelefoneBloqueado[]
    } catch (error) {
        RegistrarLogErro(error, "ObterTelefonesBloqueados", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const cadastrarTelefoneBloqueado = async function (
    authorization: string,
    payload: CadastrarPayload
): Promise<TelefoneBloqueado[] | ErroApi> {
    try {
        const response = await api
            .post<TelefoneBloqueado[] | RespostaErroRaw>("telefone-bloqueado/cadastrar", payload, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as TelefoneBloqueado[]
    } catch (error) {
        RegistrarLogErro(error, "CadastrarTelefoneBloqueado", JSON.stringify(payload))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const excluirTelefoneBloqueado = async function (
    authorization: string,
    id: number
): Promise<void | ErroApi> {
    try {
        const response = await api
            .delete<RespostaErroRaw | null>(`telefone-bloqueado/excluir/${id}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (response.data && isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
    } catch (error) {
        RegistrarLogErro(error, "ExcluirTelefoneBloqueado", String(id))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
